import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'batp-confirm-login',
  templateUrl: './confirm-login.component.html',
  styleUrls: ['./confirm-login.component.css']
})
export class ConfirmLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
